/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { FC } from "react";
import { useTranslation } from "react-i18next";

import HeaderNavLink from "~/features/header/components/HeaderNavLink";

const GuestMenuContent: FC = () => {
  const { t } = useTranslation("header");

  return (
    <>
      <li>
        <HeaderNavLink to="/#about">{t("menu.about")}</HeaderNavLink>
      </li>
      <li>
        <HeaderNavLink to="/#partners">{t("menu.partners")}</HeaderNavLink>
      </li>
      <li>
        <HeaderNavLink to="/#programs">{t("menu.programs")}</HeaderNavLink>
      </li>
      <li>
        <HeaderNavLink to="/#tools">{t("menu.tools")}</HeaderNavLink>
      </li>
      <li>
        <HeaderNavLink to="/#contact">{t("menu.contact")}</HeaderNavLink>
      </li>
      <li>
        <HeaderNavLink to="/app/signup" hasBorder>
          {t("menu.sign_up")}
        </HeaderNavLink>
      </li>
      <li>
        <HeaderNavLink to="/app/login">{t("menu.login")}</HeaderNavLink>
      </li>
    </>
  );
};

export default GuestMenuContent;
